import { Box, Button, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import backImg from "../../common/assests/backImg.png";
import TestingImg from "../../common/assests/gridimg3.png";
import { useLocation, useNavigate } from 'react-router-dom';
import './Vender.css'
import AllProductList from './AllProductList';
import NewAddedProduct from './NewAddedProduct';
import CreatedEvent from './CreatedEvent';
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import CallIcon from '@mui/icons-material/Call';
import { toast } from 'react-toastify';
import { useConfirm } from '../../common/confirmDialog/useConfirm';
import { blockVenderApi, deleteVenderApi, resumeVenderApi } from '../../api';
import { useSelector } from 'react-redux';
import UserImg from '../../common/assests/sampleuser.svg'
import configuration from '../../config/Config';



const VenderDetails = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const confirm = useConfirm();
  const navigate=useNavigate()
    const location = useLocation();
    const { selectedRow } = location.state || {};
  //  console.log("first,",selectedRow)
    
  const [activeComponent, setActiveComponent] = useState(0);
  const [accStatus, setAccStatus] = useState(selectedRow?.account_status);
  const [change, setChange] = useState(false);

  const handleToggle = (index) => {
    setActiveComponent(index);
  };

  const handleBack=()=>{
    navigate(-1)
}

const getStatusLabel = (status) => {
  switch (status) {
    case 1:
      return 'Unverified';
    case 2:
      return 'Active';
    case 3:
      return 'Blocked';
    case 4:
      return 'Deleted';
      case 5:
      return 'Rejected';
    default:
      return '-';
  }
};
 

// const handleResumeVender=async(row)=>{
//   const isConfirmed = window.confirm("Are you sure, you want to Resume this Vendor?");
//   if (!isConfirmed) {
//     return;
//   }
//     try {
//       const response = await updateUserApi({token,id:row._id,account_status:2})
//       setChange(!change);
//       toast.success(response.message)
//     } catch (error) {
//       toast.error(error.message)
//       console.log("ee",error);
//     }
// }

const handleBlockVender=async(id)=>{
    const isConfirmed = await confirm({ title: "Block Vendor", description: "Are you sure you want to block this vendor?", confirmText: "Block" });
    if (!isConfirmed) return;
      try {
        const response = await blockVenderApi({token,id,account_status:3})
        console.log("ee",response);
        setAccStatus(3)
        toast.success(response.message)
      } catch (error) {
        toast.error(error?.message||error?.error)
        console.log("error",error);
      }
  }

  const handleResumeVender=async(id)=>{
    const isConfirmed = await confirm({ title: "Resume Vendor", description: "Are you sure you want to resume this vendor?", confirmText: "Resume" });
    if (!isConfirmed) return;
      try {
        const response = await resumeVenderApi({token,id,account_status:2})
        setAccStatus(2);
        toast.success(response?.message)
      } catch (error) {
        toast.error(error?.message||error?.error)
        console.log("error",error);
      }
  }
    

  const handleDeleteVender=async(id)=>{
    const isConfirmed = await confirm({ title: "Delete Vendor", description: "Are you sure you want to delete this vendor?", confirmText: "Delete", destructive: true });
    if (!isConfirmed) return;
      try {
        const response = await deleteVenderApi({token,id})
        toast.success(response?.message)
        navigate(-1)
      } catch (error) {
        toast.error(error?.message||error?.error)
        console.log("error",error);
      }
  }
    
    
  return (
    <div style={{maxWidth:'1420px'}}>
      <Box sx={{ marginTop: '15px', paddingLeft: '10px'}}>
  <Typography
    sx={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "start",
      gap: '15px',
      width: "20%",
      alignItems: "center",
      cursor: "pointer",
    }}
    onClick={handleBack}
  >
    <img
      src={backImg}
      alt="backImg"
      style={{ height: "29px", width: "29px" }}
    />
    <Typography
      sx={{ color: "#065F46", fontWeight: "500", fontSize: "20px" }}
    >
      Back
    </Typography>
  </Typography>
</Box>

<Box
  sx={{
    borderRadius: '24px',
    backgroundColor: '#FFF',
    boxShadow: '3px 2px 20px 0px rgba(0, 0, 0, 0.04)',
    maxWidth: '1460px',
    width:'100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column', 
    padding: '16px',
    boxSizing: 'border-box',
    p:4,
    mt:'30px'
  }}
>
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center', 
      mb: '20px',
      flexWrap:'wrap',
      // gap:'10px'
      
    }}
  >
        <Typography 
      fontFamily="Heebo" 
      fontWeight={700} 
      color="#362B24"
      fontSize={20}
    >
      Vender Information
    </Typography>

<Box display="flex" flexWrap='wrap'gap={1} sx={{mt:{xs:'10px',sm:'0px',md:'0px'}}} >
  {/* <Button
    sx={{
      borderRadius: '15px',
      backgroundColor: '#065F46',
      width: { xs: '70px',sm:'100px', md: '124px' }, 
      height: { xs: '40px', md: '50px' },   
      flexShrink: 0,
      fontSize:{xs:'10px',sm:'14px'},
      color: '#FFF',
      marginLeft: '8px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#065F46',
      },
    }}
  >
    Edit Vendor
  </Button> */}
  <Button
  onClick={()=>handleDeleteVender(selectedRow?._id)}
    sx={{
      borderRadius: '15px',
      backgroundColor: '#EA001B',
      width: { xs: '70px',sm:'100px', md: '124px' },
      height: { xs: '40px', md: '50px' },   
      flexShrink: 0,
      color: '#FFF',
      marginLeft: '8px',
      textTransform: 'none',
      fontSize:{xs:'10px',sm:'14px'},
      '&:hover': {
        backgroundColor: '#EA001B',
      },
    }}
  >
    Delete
  </Button>
  <Button
    onClick={() => (accStatus === 3 ? handleResumeVender(selectedRow._id) : handleBlockVender(selectedRow._id))}
    sx={{
      borderRadius: '15px',
      backgroundColor: '#362B24',
      width: { xs: '70px',sm:'100px', md: '124px' },
      height: { xs: '40px', md: '50px' },   
      flexShrink: 0,
      color: '#FFF',
      marginLeft: '8px',
      textTransform: 'none',
      fontSize:{xs:'10px',sm:'14px'},
      '&:hover': {
        backgroundColor: '#362B24',
      },
    }}
  >
  {accStatus === 3 ? 'Resume' : 'Block'}  
  </Button>
</Box>

  </Box>

  {/* Grid layout  */}
 <Grid container alignItems="flex-start" gap={3} mt={5} mb={2}>
  {/* Single Row: Image and Text Column */}
  <Grid item xs={12} md={4} lg={4.5}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: { xs: 'center',sm:'center', md: 'center',lg:'center',xl:'start' },
        // mt: { xs: '10px',sm:'10px' },
        textAlign: { xs: 'center', md: 'left',lg:'center' },
        flexWrap:'wrap',
        gap:'10px',
        maxWidth:"100%"
        
      }}
    >
      <Box
        component="img"
        src={selectedRow?.picture 
          ? `${configuration.cdnFront}/${selectedRow?.picture}` 
          : UserImg}  
        alt={selectedRow?.fullname || 'User'}
        sx={{
          objectFit: 'cover',
          borderRadius: '50%',
          height: '100px',
          width: '100px',
          // mr: { lg:3,xl: 3, xs: 0 },
         
          mb: { xs: 2, md: 0 },
           maxWidth:{md:"100%"},
           wordWrap:"break-word"
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap:'wrap',
          marginTop:{md:'25px',xl:'0px'},
          alignItems: { xs: 'center',xl:'flex-start' }, 
          alignContent: { xs: 'center',xl:"center"  },
          gap: '15px',
          
        }}
      >
        <div style={{ fontSize: '20px', fontWeight: '600', color: '#362B24',wordBreak:"break-word"  }}>
          {selectedRow?.fullname||"N/A"}
        </div>
        <div style={{ color: '#065F46', display: 'flex', alignItems: 'center', mt: 1,wordBreak:"break-word" }}>
          <EmailRoundedIcon style={{ mr: 1 }} />
         {selectedRow?.email||"-"}
        </div>
        <div style={{ color: '#065F46', display: 'flex', alignItems: 'center', mt: 1 }}>
          <CallIcon style={{ mr: 1 }} />
          {selectedRow?.phone||"-"}
        </div>
      </Box>
    </Box>
  </Grid>

  {/* Second Column */}
  <Grid item xs={12} md={7.4} lg={7} maxWidth="100%" flexGrow="1" >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {/* First Grid Row */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs:'repeat(2, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)',lg: 'repeat(4, 1fr)',xl:'repeat(5, 1fr)' },
          gap: '16px',
          mt:{sm:'20px',md:'0px'}
        }}
      >
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Status</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>
            <strong>{getStatusLabel(accStatus)}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Created Date</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>
            <strong>{selectedRow?.createdAt
  ? new Date(selectedRow.createdAt).toLocaleDateString('en-US')
  : "-"}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Bank Detail</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px',wordBreak:"break-word" }}>
            <strong>{selectedRow?.filled||"-"}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Total Balance</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px', }}>
            <strong>{selectedRow?.totalAmount ? `$${selectedRow?.totalAmount||"-"}`:"-"}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Bank Name</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px',wordBreak:"break-word" }}>
            <strong>{selectedRow?.bankName||"-"}</strong>
          </Typography>
        </Box>
      </Box>

      {/* Second Grid Row */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {  xs:'repeat(2, 1fr)', sm: 'repeat(3, 1fr)' },
          gap: '16px',
        }}
      >
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Account No</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px',wordBreak:"break-word" }}>
            <strong>{selectedRow?.accountNo||"-"}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Account Type</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px',wordBreak:"break-word" }}>
            <strong>{selectedRow?.accountType||"-"}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Address</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px',wordBreak:"break-word" }}>
            <strong>{selectedRow?.address?.address||"-"}</strong>
          </Typography>
        </Box>
      </Box>

      {/* Third Grid Row */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {  xs:'repeat(2, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
          gap: '16px',
          // mt:{md:'10px',lg:'10px'}
        }}
      >
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>City</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>
            <strong>{selectedRow?.address?.city||"-"}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>State</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>
            <strong>{selectedRow?.address?.state||"-"}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Country</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>
            <strong>{selectedRow?.address?.country||"-"}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: '400', opacity: '0.6', color: '#362B24' }}>Zip Code</Typography>
          <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>
            <strong>{selectedRow?.address?.zipcode||"-"}</strong>
          </Typography>
        </Box>
      </Box>
    </Box>
  </Grid>
</Grid>


</Box>





      

<div className="vendor-detail-toggle-container d-flex justify-content-between align-items-center flex-wrap mt-4">
  <div className="vendor-detail-button-box">
    <div
      id="vendor-detail-btn"
      style={{ 
        left: `${activeComponent * 32.5}%`, 
        width: `33.33%` 
      }}
    ></div>
    <button
      className={`vendor-detail-toggle-btn ${activeComponent === 0 ? 'active' : ''}`}
      onClick={() => handleToggle(0)}
    >
     All Product list
    </button>
    <button
      className={`vendor-detail-toggle-btn ${activeComponent === 1 ? 'active' : ''}`}
      onClick={() => handleToggle(1)}
    >
     New Added Product
    </button>
    <button
      className={`vendor-detail-toggle-btn ${activeComponent === 2 ? 'active' : ''}`}
      onClick={() => handleToggle(2)}
    >
      Created Events
    </button>
  </div>
</div>


{activeComponent === 0 && <AllProductList />}
{activeComponent === 1 && <NewAddedProduct />}
{activeComponent === 2 && <CreatedEvent />}
     


    
   
    </div>
  )
}

export default VenderDetails